// 모바일(≤768) 하단 고정 5탭 — 시안 A0 `.mtabs`. 아이콘은 인라인 SVG(이모지 금지).
// props: { items: [{ id, label, onClick }], activeId }   id = 라우트 탭 id(home/requests/fees/manage/more)
import React from 'react';
import { T } from '../../theme';

function Glyph(props) {
  var p = {
    home: 'M4 10.5L12 4l8 6.5V20h-5.4v-5.2H9.4V20H4v-9.5z',
    car: 'M3 13l1.6-4.4A2 2 0 016.5 7h7.3a2 2 0 011.9 1.3L17 13M3 13h14v4H3v-4zm2.5 4v1.6M14.5 17v1.6',
    receipt: 'M6 3h12v18l-2.2-1.6L13.6 21l-2.2-1.6L9.2 21 7 19.4 6 21V3zM9 8h6M9 12h6',
    grid: 'M4 4h6.4v6.4H4zM13.6 4H20v6.4h-6.4zM4 13.6h6.4V20H4zM13.6 13.6H20V20h-6.4z',
    more: 'M5.5 12h.01M12 12h.01M18.5 12h.01',
    doc: 'M7 3h7l5 5v13H7zM14 3v5h5'
  }[props.id] || '';
  return (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={props.id === 'more' ? 2.6 : 1.7} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d={p} />
    {props.id === 'car' ? <circle cx="18" cy="8.5" r="3.6" /> : null}
  </svg>);
}

// 탭 id → 글리프. malso·ledger = 말소 셸(B3·B4) 탭.
var GLYPH = { home: 'home', requests: 'car', fees: 'receipt', manage: 'grid', more: 'more', malso: 'doc', ledger: 'receipt' };

// 열 수는 items.length — 검차 셸 5탭·말소 셸 2탭(B4 정산 삽입 시 3) 공용.
var bar = { position: 'fixed', insetInlineStart: 0, insetInlineEnd: 0, bottom: 0, height: 60, zIndex: 60,
  borderTop: '1px solid ' + T.bd, background: T.card, display: 'grid' };
var tab = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3,
  minWidth: 0, border: 0, background: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: 0 };
var text = { fontSize: 10, fontWeight: 700, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

function BottomTabs(props) {
  var items = props.items || [];
  var style = Object.assign({}, bar, { gridTemplateColumns: 'repeat(' + items.length + ', minmax(0, 1fr))' });
  return (<nav className="ss-bottom-tabs" style={style}>
    {items.map(function (it) {
      var on = it.id === props.activeId;
      return (<button key={it.id} type="button" data-tab={it.id} aria-current={on ? 'page' : undefined}
        style={Object.assign({}, tab, { color: on ? T.accentPress : T.faint })} onClick={it.onClick}>
        <Glyph id={GLYPH[it.id] || it.id} />
        <span style={text}>{it.label}</span>
      </button>);
    })}
  </nav>);
}

export default BottomTabs;
